module.exports = __webpack_public_path__ + "static/Dare-007fb611422a266738760480b3b679da.png";